export default "__VITE_ASSET__CoT8BiSy__"